'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'link-horizontal';
var width = 576;
var height = 512;
var aliases = ["chain-horizontal"];
var unicode = 'e1cb';
var svgPathData = ['M128 320c0-12.4 1.4-24.5 4.1-36.1 16.4-71 80-123.9 155.9-123.9l90.5 0c1.8 5 3.1 10.2 4.1 15.5 .5 2.7 .8 5.4 1 8.1s.4 5.5 .4 8.3c0 11.2-1.9 22-5.5 32L288 224c-41.8 0-77.4 26.7-90.5 64-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32c13.2 37.3 48.7 64 90.5 64l128 0c53 0 96-43 96-96 0-43.2-28.5-79.7-67.7-91.8l-.4-.1c1.3-5.8 2.4-11.7 3.1-17.8 .3-3 .6-6.1 .8-9.1s.3-6.1 .3-9.2c0-10-.9-19.8-2.7-29.3 74.4 13.8 130.7 79 130.7 157.3 0 88.4-71.6 160-160 160l-128 0c-78.4 0-143.5-56.3-157.3-130.7-1.8-9.5-2.7-19.3-2.7-29.3z', 'M384 192c0 53-43 96-96 96l-90.5 0c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32l90.5 0c88.4 0 160-71.6 160-160S376.4 32 288 32L160 32c-88.4 0-160 71.6-160 160 0 78.4 56.3 143.5 130.7 157.3-1.8-9.5-2.7-19.3-2.7-29.3 0-12.4 1.4-24.5 4.1-36.1-39.4-12-68.1-48.6-68.1-91.9 0-53 43-96 96-96l128 0c53 0 96 43 96 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkHorizontal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;